




















import { Component, Prop, Vue } from "vue-property-decorator";
import { IOperator } from "@/models/tables";
import { FilterTypes } from "@/data/table";

@Component
export default class SelectOperator extends Vue {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public type!: FilterTypes;

  @Prop({ required: true })
  public operators!: IOperator[];

  @Prop({ default: "" })
  public placeholder!: string;

  @Prop({ default: false })
  public disabled!: boolean;

  public getOperatorLabel(operator: IOperator) {
    return operator.label;
  }
}
